<template>

  <div class="user-profile-resume">
    <div class="container">
        <tabs :options="{ defaultTabHash: 'first-tab' }">
          <tab id="first-tab" name="Información General">
            <UserProfileGeneralInfo></UserProfileGeneralInfo>
          </tab>
          <tab id="second-tab" name="Dirección">
            <UserProfileAddress></UserProfileAddress>
          </tab>
          <tab id="third-tab" name="Información Profesional">
            <UserProfileProfession></UserProfileProfession>
          </tab>
          <tab id="fourth-tab" name="Beneficiarios">
            <UserProfileBeneficiaries></UserProfileBeneficiaries>
          </tab>
          <tab id="fifth-tab" name="Anexos">
            <UserProfileAnnexes></UserProfileAnnexes>
          </tab>
          <tab id="sixth-tab" name="Contratos">
            <UserProfileContracts></UserProfileContracts>
          </tab>
          <tab id="seven-tab" name="Estados de Cuenta">
            <UserProfileStatement></UserProfileStatement>
          </tab>
          <tab id="eight-tab" name="Facturas">
            <UserProfileInvoices></UserProfileInvoices>
          </tab>
          <tab id="nine-tab" name="Cambios en el Contrato">
            <UserProfileChangesContract></UserProfileChangesContract>
          </tab>
        </tabs>
    </div>
  </div>

</template>

<script>

import UserProfileGeneralInfo
  from '@/views/userProfile/userProfileResume/UserProfileGeneralInfo'
import UserProfileAddress
  from '@/views/userProfile/userProfileResume/UserProfileAddress'
import UserProfileProfession
  from '@/views/userProfile/userProfileResume/UserProfileProfession'
import UserProfileBeneficiaries
  from '@/views/userProfile/userProfileResume/UserProfileBeneficiaries'
import UserProfileAnnexes
  from '@/views/userProfile/userProfileResume/UserProfileAnnexes'
import UserProfileContracts
  from '@/views/userProfile/userProfileResume/UserProfileContracts'
import UserProfileChangesContract
  from '@/views/userProfile/userProfileResume/UserProfileChangesContract'
import UserProfileStatement
  from '@/views/userProfile/userProfileResume/UserProfileStatement'
import UserProfileInvoices
  from '@/views/userProfile/userProfileResume/UserProfileInvoices'

import { Tabs, Tab } from 'vue-tabs-component'

import mixins from '@/mixins/index'

export default {
  name: 'UserProfileResume',
  data () {
    return {
    }
  },
  mixins: [mixins],
  components: {
    Tabs,
    Tab,
    UserProfileGeneralInfo,
    UserProfileAddress,
    UserProfileProfession,
    UserProfileBeneficiaries,
    UserProfileAnnexes,
    UserProfileStatement,
    UserProfileContracts,
    UserProfileInvoices,
    UserProfileChangesContract
  },
  methods: {
    civilState: function (bool) {
      let state

      if (bool === true) {
        state = 'Casado'
      } else if (bool === false) {
        state = 'Soltero'
      }

      return state
    }
  }
}

</script>

<style lang="scss">

.tabs-component {
  margin: 3rem 0;
}

.tabs-component-panels {
  border-top-left-radius: 0;
  background-color: $grey;
  border: solid 1px #ddd;
  border-radius: 0 6px 6px 6px;
  box-shadow: 0 0 10px rgba(0, 0, 0, .05);
  padding: 2rem 2rem;
}

.tabs-component-tabs li:last-child {
  background: $grey;
  color: $black;
}
</style>



// WEBPACK FOOTER //
// src/views/userProfile/UserProfileResume.vue